import { RefObject, useCallback, useEffect, useState } from 'react';
import { type ColorScheme } from './MainButton';
import { getContrastColor } from '../../../utils';

// Maybe re-use this for other components once we know more
export default function useTextColor({
  ref,
  colorScheme,
}: {
  ref: RefObject<HTMLButtonElement | null>;
  colorScheme: ColorScheme;
}) {
  const [textColor, setTextColor] = useState('#2d2d2d');

  const calculateTextColor = useCallback(() => {
    if (!ref.current) return '#2d2d2d';

    const computedStyle = window.getComputedStyle(ref.current);

    return getContrastColor(computedStyle.backgroundColor);
  }, [ref]); // Re-run effect if primaryColor state changes

  useEffect(() => {
    const $el = ref.current;

    if (!$el) return () => {};

    setTextColor(calculateTextColor());

    const obs = new MutationObserver(() => {
      setTextColor(calculateTextColor());
    });

    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });

    const handleHoverAnimations = () => {
      setTextColor(calculateTextColor());
    };

    $el.addEventListener('transitionend', handleHoverAnimations);

    return () => {
      $el?.removeEventListener('transitionend', handleHoverAnimations);
      obs.disconnect();
    };
  }, [ref, colorScheme, calculateTextColor]);

  return textColor;
}
